import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { Transport } from '../../../../src/api/cart/interfaces'
import SelectCustomField, { Option } from './SelectField'

const mapTransportToDropdown = (transports: Array<Transport>): Option[] => {
  const options: Option[] = transports?.map((t) => {
    return { value: t.id, label: t.carrier !== '' ? t.carrier : t.releaseCode }
  })

  return options ?? []
}

interface TransportDropdownProps {
  value: string
  transports: Transport[]
  onChange: (value: string) => void
}

const TransportsDropdown = observer(
  (props: TransportDropdownProps): ReactElement => {
    const { value, transports, onChange } = props

    const options = mapTransportToDropdown(transports)

    if (options.length === 0) return null

    return (
      <SelectCustomField
        options={options}
        value={value}
        title="transport"
        onSelect={(e) => {
          onChange(e as string)
        }}
        width="auto"
        cursorType="pointer"
      />
    )
  }
)

export default TransportsDropdown
